// extracted by mini-css-extract-plugin
export default {"breadcrumb":"customBreadCrumb_breadcrumb__i7PIf"};